// @flow

import createApiModule from "../create-api-module";
import { type PathParams } from "./event-details.d";

const { reducer, actions } = createApiModule(
    "eventDetailsPlanable",
    ({ uuid }: PathParams) =>
        `/ays-series-event-management/events/${uuid}/_planable`,
    { method: "POST" },
);

export const load = (uuid: string) => (dispatch: *) => {
    return dispatch(
        actions.load({
            path: { uuid },
            data: true,
        }),
    );
};
export const clear = actions.clear;
export const refetch = actions.refetch;

export default reducer;
